import { withStyles } from '../../tools/withStyles';
import { Component } from './Layout';
import { styles } from './Layout.styles';

const Layout = withStyles(styles)(Component);

export { Layout };
